module.exports = __webpack_public_path__ + "static/media/percent.1806cac9.svg";